import { render, staticRenderFns } from "./ViewNotice.vue?vue&type=template&id=722900e4&scoped=true"
import script from "./ViewNotice.vue?vue&type=script&lang=js"
export * from "./ViewNotice.vue?vue&type=script&lang=js"
import style0 from "./ViewNotice.vue?vue&type=style&index=0&id=722900e4&prod&scoped=true&lang=css"
import style1 from "./ViewNotice.vue?vue&type=style&index=1&id=722900e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722900e4",
  null
  
)

export default component.exports